<template>
    <DatatablePageLayout>
        <template v-slot:actionButtons>
            <button class="sk-btn sk-btn-primary rounded-lg" @click="handleCreate">
                {{ $t('apps.campaigns.form.createButton') }}
            </button>
        </template>
        <template v-slot:datatable>
            <DataTable 
                :config="datatableConfig" 
                :elements="templates" 
                :stripe="true" 
                :draggable="false"
                :sst="true" 
                :pagination="pagination" 
                @action="handleAction" 
                @filter="handleFilter" 
            />
        </template>
    </DatatablePageLayout>
</template>

<script>

import { v4 as uuidv4 } from 'uuid';
import loader from "@/modules/Shared/Mixins/loader";
import DataTable from "@/modules/Shared/Components/table/SKDataTable.vue";
import PaginationService from "@/modules/Shared/Services/PaginationService";
import DatatablePageLayout from "@/modules/Shared/Pages/DatatablePageLayout.vue";
import AppConditionTemplateService from "@/modules/Admin/Services/AppConditionsService";

export default {
    name: "AppConditionsPage",
    components: { DataTable, DatatablePageLayout },
    mixins: [loader],
    data() {
        return {
            templates: [],
            datatableConfig: [
                { 'field' : 'reference', head : this.$t('admin.app-conditions.reference'), 'searchable' : true, 'sortable' : false},
                { 'field' : 'template', head : this.$t('admin.app-conditions.template'), 'searchable' : true, 'sortable' : false},
                { 'field' : 'actions', 'type': 'actions', head : this.$t("geofences.geofences-messages.actions"), 'searchable' : false, 'sortable' : false }
            ],
            pagination: {},
        }
    },
    async created() {
        this.loadAndNotifyError(async () => {
            await this.getConditions({
                filters: [],
                page: 1
            })
        })
    },
    methods: {
        async getConditions(params) {
            const conditionResponse = await AppConditionTemplateService.getAppConditions(PaginationService.parseParameters(params))
            this.templates = this.parseTemplates(conditionResponse.data)
              this.pagination = {
                  per_page: conditionResponse.per_page,
                  total: conditionResponse.total
              }
        },

        parseTemplates(conditions) {
            return conditions.map(template => ({
                ...template,
                actions: [ 'edit' ]
            }))
        },

        async handleFilter(params) {
            await this.getConditions(params)
        },
        async handleAction(type, uuid){
            switch(type) {
                case 'edit':
                    await this.$router.push({
                        name: 'admin-app-condition-create',
                        params: { uuid: uuid }
                    })
                    break
            }
        },
        async handleCreate() {
            await this.$router.push({
                name: 'admin-app-condition-create',
                params: { uuid: uuidv4() }
            })
        },
    }
};
</script>